<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import { getStorage } from '@/utils'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
window.APP_CONFIG = window.APP_CONFIG || {}
export default {
  name: 'App',
  data () {
    return {
      locale: zhCN
    }
  },
  mounted() {
    const logo = getStorage('logo', 0)
    if (logo) {
      document.querySelector('link[rel="icon"]').setAttribute('href', logo)
    }
  }
}
</script>
